import { render, staticRenderFns } from "./TrainPointOfUse.vue?vue&type=template&id=f183264c&scoped=true&"
import script from "./TrainPointOfUse.vue?vue&type=script&lang=js&"
export * from "./TrainPointOfUse.vue?vue&type=script&lang=js&"
import style0 from "./TrainPointOfUse.vue?vue&type=style&index=0&id=f183264c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f183264c",
  null
  
)

export default component.exports